module.exports = __webpack_public_path__ + "assets/img/2-mobile.f3a7dfa8.png";